import React from 'react';
import serialize from 'form-serialize';
import Input from './input';
import ErrorMessenger from './error-messenger';

class Form extends React.Component {
    constructor(props){
        super(props);

        this.errorMessengers = {};
        this.fields = {};

        this.submitted = false;
    }

    componentWillMount() {
        this.submitted = false;
    }

    componentDidMount() {
        this.refs.formElement.addEventListener('invalid', this.handleInvalid);
    }

    componentWillUnmount() {
        this.refs.formElement.removeEventListener('invalid', this.handleInvalid);
    }

    get errors() {
        let errors = {};
        for (var i = 0; i < this.refs.formElement.elements.length; i++) {
            let element = this.refs.formElement.elements[i];
            if (!element.validity.valid) {
                errors[element.name] = element.validationMessage;
            }
        }

        Object.keys(this.fields).forEach(key => {
            let field = this.fields[key];

            if (field.error) {
                errors[key] = field.error;
            }
        });

        return errors;
    }

    get data(){
        let organicData = serialize(this.refs.formElement, { hash: true });
        let data = {};
        Object.keys(this.fields).forEach(key => {
            let field = this.fields[key];

            if (field.valid) {
                data[field.props.name] = this.fields[field.props.name].value;
            }
        });

        return Object.assign({}, organicData, data);
    }

    get valid() {
        return this.refs.formElement.checkValidity() && Object.keys(this.fields).every(key => {
            let field = this.fields[key];

            return (typeof field.valid === 'boolean') && field.valid;
        });
    }

    registerErrorMessenger(component){
        if (!component.props.fieldName) {
            console.error('Can\'t register an error messenger without a fieldName');
            return;
        }
        this.errorMessengers[component.props.fieldName] = component;

        return () => {
            delete this.errorMessengers[component.props.fieldName];
        }
    }

    clearErrorMessengers(){
        Object.keys(this.errorMessengers).forEach(key => {
            let messenger = this.errorMessengers[key];
            messenger.clear();
        });
    }

    registerField(field) {
        if (!field.props.name) {
            throw new Error('Can\'t add a field without a name to a Form.');
        }

        this.fields[field.props.name] = field;

        return () => {
            delete this.fields[field.props.name];
        }
    }

    updateMessengers() {
        const errors = this.errors;

        Object.keys(errors).forEach(key => {
            let error = errors[key];
            let messenger = this.errorMessengers[key];

            if (messenger) {
                messenger.notify(error);
            }
        });
    }

    handleError(event) {
        if ( typeof this.props.onError === 'function') {
            this.props.onError(event, this.errors);
        }

        this.updateMessengers();
    }

    handleChange(event) {
        this.clearErrorMessengers();
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(event, this.data);
        }

        if (this.submitted) {
            this.updateMessengers();
        }
    }

    handleSubmit(event) {
        this.submitted = true;
        event.preventDefault();
        if (!this.valid) {
            this.handleError(event);
            return;
        }
        if (typeof this.props.onSubmit === 'function') {
            this.props.onSubmit(event, this.data);
        }
    }

    renderElement(element, key){
        if (Array.isArray(element)) {
            return element.map((child, i) => {
                return this.renderElement(child, i);
            });
        } else if(React.isValidElement(element)){
            let children = React.Children.map(element.props.children, (child, i) => {
                return this.renderElement(child, i);
            });

            let newProps = {
                children,
                key
            }

            if (element.type === Input) {
                if (!element.props.name) {
                    console.warn(`No "name" prop found on an Input Component in ${element._self.constructor.name}! Inputs must have a name property in order to be properly included in Form submissions.`);
                } else {
                    newProps.form = this;
                }
            }

            if (element.type === ErrorMessenger) {
                if (element.props.fieldName) {
                    newProps.form = this;
                }
            }

            return React.cloneElement(element, newProps);
        } else {
            return element;
        }
    }

    render () {
        return (
            <form {...this.props} ref="formElement" onSubmit={e => this.handleSubmit(e)} onChange={e => this.handleChange(e)} className={['component-form', this.props.className].join(' ')} noValidate>
                { this.renderElement(this.props.children) }
            </form>
        )
    }
}

export default Form;



// WEBPACK FOOTER //
// ./web-app/components/form.jsx